module.exports = __webpack_public_path__ + "static/media/unarchive.069f52a2.svg";